import ExteriorScreenContainer from './ExteriorScreenContainer'

export default ExteriorScreenContainer
